import React, { useEffect, useCallback } from "react";
import $ from "jquery";

// INDICACIONES:
// Si se desea crear un modal debe tener el atributo "id", ya que con ese se puede mostrar y ocultar en pantalla
// Además, debe tener un atributo "isVisible" desde el componente invocante (un hook). SIEMPRE DEBE ESTAR INICIALIZADO EN false.
// Si se desea mostrar el modal al inicio (al cargar la página) el atributo "isVisible" DEBE CAMBIARSE DE false A true por medio de un
// useEffect().

const CustomModal = ({
  id,
  headerTitle,
  headerSubtitle,
  headerIcon,
  headerBackgroundColor,
  headerTextColor,
  borderRadius,
  size,
  children,
  isVisible,
  onCloseModal,
  hasCloseButton,
  preventCloseOnClickOutside,
}) => {
  const modalAttributes = preventCloseOnClickOutside
    ? {
        "data-backdrop": "static",
        "data-keyboard": "false",
      }
    : {};

  const toggleModalVisibility = useCallback(() => {
    if (isVisible) {
      $(`#${id}`).modal("show");
    } else {
      $(`#${id}`).modal("hide");
    }
  }, [id, isVisible]);

  useEffect(() => {
    toggleModalVisibility();
  }, [toggleModalVisibility]);

  useEffect(() => {
    // Este listener se encarga de ejecutar la función onCloseModal cada vez que el usuario cierra el modal,
    // esa función permite que se logre ocultar el componente
    $(`#${id}`).on("hidden.bs.modal", onCloseModal);
    return () => {
      // Para destruir el modal por completo, se tienen que eliminar manualmente sus componentes del body también
      $(".modal-backdrop").remove();
      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("padding-right");
      $(`#${id}`).off("hidden.bs.modal", onCloseModal);
    };
  }, [id, onCloseModal]);

  return (
    <div
      id={id}
      className="modal custom-modal fade hide"
      tabIndex="-1"
      aria-labelledby="customModal"
      {...modalAttributes}
    >
      <div
        className={`modal-dialog modal-dialog-centered modal-dialog-scrollable ${
          size ? `modal-${size}` : ""
        }`}
        role="document"
      >
        <div className={`modal-content rounded-${borderRadius ?? "xl"}`}>
          <div className={`modal-header bg-${headerBackgroundColor ?? "primary"}`}>
            <h3 className={`modal-title text-${headerTextColor ?? "white"}`}>
              <div className="row">
                {headerIcon && (
                  <div className="col-1 my-auto mr-4">
                    <i className={`${headerIcon}`} />
                  </div>
                )}
                <div className="col">
                  {headerTitle}
                  <br />
                  <small>{headerSubtitle}</small>
                </div>
              </div>
            </h3>
            {hasCloseButton && (
              <div className="modal-close" role="button" data-dismiss="modal" aria-label="Close">
                <i className={`fas fa-times text-${headerTextColor ?? "white"}`} />
              </div>
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
